import { PACKAGES_QUERY_PARAM as CORE_PACKAGES_QUERY_PARAM } from "@b2bportal/core-packages";

/**
 * RBC extension of PACKAGES_QUERY_PARAM that adds infant URL params.
 * Re-exported from packagesOverride.ts so any import from @tenant/packages
 * gets the extended version automatically.
 */
export const PACKAGES_QUERY_PARAM = {
  ...CORE_PACKAGES_QUERY_PARAM,
  infantsOnLap: "infants_on_lap",
  infantsInSeat: "infants_in_seat",
} as const;
